<template>
  <b-overlay
    :show="loading"
    class="row bg-white  p-4"
  >
    <div class="col-12">
      <div class="row">
        <form
          class="col-12"
          data-vv-scope="form-rescue"
          autocomplete="off"
          @submit.prevent
        >
          <b-row>
            <b-col cols="12">
              <b-form-group
                label="Número F-09 (*)"
                label-for="#"
              >
                <b-input-group class="input-group-merge">
                  <b-input-group-prepend is-text>
                    <feather-icon icon="HashIcon"/>
                  </b-input-group-prepend>
                  <b-form-input
                    placeholder="Nro F-09"
                    v-model="f09Numero"
                    data-vv-as="Nro F-09"
                    v-validate="'required'"
                    name="f09Numero"
                    data-cy="f09-numero"
                    :state="errors.has('form-rescue.f09Numero') ? false : null"
                  />
                  <b-form-invalid-feedback>
                    {{ errors.first('form-rescue.f09Numero') }}
                  </b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group label="Fecha Pago Formulario (*)">
                <date-picker
                  placeholder="Fecha Pago Formulario"
                  v-model="f09FechaPago"
                  class="w-100"
                  format="DD MMM YYYY"
                  value-type="YYYY-MM-DD"
                  type="date"
                  data-vv-as="fecha pago formulario"
                  v-validate="'required'"
                  name="f09FechaPago"
                  data-cy="f09-fecha-pago"
                />
                <div v-if="errors.has('form-rescue.f09FechaPago')">
                  <small class="text-danger">
                    {{ errors.first('form-rescue.f09FechaPago') }}
                  </small>
                </div>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group label="Monto Cancelado (*)">
                <b-input-group class="input-group-merge">
                  <b-input-group-prepend is-text>
                    <feather-icon icon="DollarSignIcon"/>
                  </b-input-group-prepend>
                  <b-form-input
                    type="number"
                    placeholder="Monto cancelado"
                    v-model="f09MontoPago"
                    data-vv-as="Monto cancelado"
                    v-validate="'required'"
                    name="f09MontoPago"
                    data-cy="f09-monto-pago"
                    :state="errors.has('form-rescue.f09MontoPago') ? false : null"
                  />
                  <b-form-invalid-feedback>
                    {{ errors.first('form-rescue.f09MontoPago') }}
                  </b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group label="Número Resolución (*)">
                <b-input-group class="input-group-merge">
                  <b-input-group-prepend is-text>
                    <feather-icon icon="HashIcon"/>
                  </b-input-group-prepend>
                  <b-form-input
                    type="number"
                    placeholder="Número Resolución"
                    v-model="numeroResolucion"
                    data-vv-as="Número de Resolución"
                    v-validate="'required'"
                    name="numeroResolucion"
                    data-cy="numero-resolucion"
                    :state="errors.has('form-rescue.numeroResolucion') ? false : null"
                  />
                  <b-form-invalid-feedback>
                    {{ errors.first('form-rescue.numeroResolucion') }}
                  </b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group label="Fecha Resolución (*)">
                <date-picker
                  placeholder="Fecha de Resolución"
                  v-model="fechaResolucion"
                  class="w-100"
                  format="DD MMM YYYY"
                  value-type="YYYY-MM-DD"
                  type="date"
                  data-vv-as="fecha de resolución"
                  v-validate="'required'"
                  name="fechaResolucion"
                  data-cy="fecha-resolucion"
                />
                <div v-if="errors.has('form-rescue.fechaResolucion')">
                  <small class="text-danger">
                    {{ errors.first('form-rescue.fechaResolucion') }}
                  </small>
                </div>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group label="Motivo del rescate (*)">
                <b-form-textarea
                  placeholder=""
                  v-model="cause"
                  data-vv-as="Motivo del rescate"
                  v-validate="'required'"
                  name="cause"
                  data-cy="cause"
                  max
                  maxlength="500"
                  rows="4"
                  :state="errors.has('form-rescue.cause') ? false : null"
                />
                <b-form-invalid-feedback>
                  {{ errors.first('form-rescue.cause') }}
                </b-form-invalid-feedback>
                <small
                  class="textarea-counter-value float-right"
                  :class="cause.length >= maxChar ? 'bg-danger' : ''"
                >
                  <span class="char-count">{{ cause.length }}</span> / {{ maxChar }}
                </small>
              </b-form-group>
            </b-col>
            <vs-divider></vs-divider>
            <b-col
              cols="12"
              class="text-right"
            >
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                v-on:click="onRescue"
              >
                Si!, Estoy seguro.
              </b-button>
            </b-col>
          </b-row>
        </form>
      </div>
    </div>
  </b-overlay>
</template>
<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';

import { cancelRescue } from '@/febos/servicios/api/aduanas/batches.api';

export default {
  name: 'PopUpRescue',
  components: {
    DatePicker
  },
  data() {
    return {
      loading: false,
      f09Numero: '',
      f09FechaPago: '',
      f09MontoPago: '',
      numeroResolucion: '',
      fechaResolucion: '',
      cause: '',
      maxChar: 500,
    };
  },
  props: ['batch'],
  methods: {
    async onRescue() {
      const isValid = await this.$validator.validateAll('form-rescue');
      if (!isValid) {
        return;
      }
      this.loading = true;
      try {
        await cancelRescue({
          loteId: this.batch.loteId,
          message: this.cause,
          f09Numero: this.f09Numero,
          f09FechaPago: this.f09FechaPago,
          f09MontoPago: this.f09MontoPago,
          numeroResolucion: this.numeroResolucion,
          fechaResolucion: this.fechaResolucion
        });
        this.$emit('rescue');
      } finally {
        this.loading = false;
      }
    }
  },
  created() {
    this.cause = '';
  }
};
</script>

<style>
.mx-input {
  padding: 20px 10px 20px 35px;
  color: #6e6b7b;
}
.mx-icon-calendar {
  left: 10px
}
</style>
